<div class="logements-page">
  <header class="logements-header">
    <div>
      <h2 class="logements-title">{{ 'logements.ajout.title' | translate }}</h2>
      <p class="logements-subtitle">{{ 'logements.ajout.subtitle' | translate }}</p>
    </div>
  </header>

  <form class="logements-form" (ngSubmit)="submit()" [formGroup]="form">
    <label>
      {{ 'logements.ajout.titre' | translate }}
      <input type="text" formControlName="titre" autocomplete="off" />
    </label>

    <label>
      {{ 'logements.ajout.rue' | translate }}
      <input type="text" formControlName="rue" autocomplete="address-line1" />
    </label>

    <div class="logements-form-row">
      <label>
        {{ 'logements.ajout.codePostal' | translate }}
        <input type="text" formControlName="codePostal" autocomplete="postal-code" />
      </label>
      <label>
        {{ 'logements.ajout.ville' | translate }}
        <input type="text" formControlName="ville" autocomplete="address-level2" />
      </label>
    </div>

    <label>
      {{ 'logements.ajout.complement' | translate }}
      <span class="logements-optional">{{ 'common.optional' | translate }}</span>
      <input
        type="text"
        formControlName="complement"
        autocomplete="address-line2"
        />
      </label>

      <label>
        {{ 'logements.ajout.anneeConstruction' | translate }}
        <span class="logements-optional">{{ 'common.optional' | translate }}</span>
        <input
          type="number"
          min="1000"
          max="9999"
          step="1"
          formControlName="anneeConstruction"
          />
        </label>

      @if (error) {
        <p class="logements-status logements-status--error">
          {{ 'logements.ajout.saveError' | translate }}
        </p>
      }

      <div class="logements-form-actions">
        <a [routerLink]="routes.logements" class="logements-cancel">{{
          'common.cancel' | translate
        }}</a>
        <button type="submit" class="logements-action-btn" [disabled]="saving">
          {{
          saving
          ? ('common.saving' | translate)
          : ('common.save' | translate)
          }}
        </button>
      </div>
    </form>
  </div>
